<section class="content tab-section d-flex">
    <div class="content-block flex-grow-1">
        <div class="search-cont">
            <div class="s-in form-input" >
                <mat-icon class="input-icon">search</mat-icon>
                <input type="text"  placeholder="Search" class="form-control" [(ngModel)]="searchInput"    (input)="onSearch($event)" (keyup.enter)="onGo()" />
              </div>
            <div class="go-b" (click)="onGo()">Go</div>
            <div class="s-item d-box " (click)="onFilterView()">
                <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
            </div>
        </div>
        <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
        <div class="flex-grow-1 position-relative" *ngIf="isSpinnerLoading">
            <div class="custom-loader"></div>
        </div>
        <div class="flex-grow-1 d-flex flex-column" *ngIf="!isSpinnerLoading">
            <div class="heading-2  mt-3">Buy Courses</div>
            <div class="row ">
                <div class="col-12  col-sm-6  col-md-4 col-xxl-3 d-flex flex-column" *ngFor="let item of courseArr">
                    <div class="c-box h-100 d-flex flex-column">
                        <div class="c-img" [appBackgroundImg]="item.img" [iType]="'course'"></div>
                        <div class="c-content d-flex flex-column flex-grow-1">
                            <div>
                                <div class="heading-3 clamp-line-1">{{item.tit | truncate:40}}</div>
                                <div class="c-txt  c-desc c-desc-new">{{item.dep}}</div>
                            </div>
                            <div class="flex-grow-1 d-flex flex-column justify-content-end">
                                    <div class="d-flex flex-wrap">
                                        <div class="sect-b    l-txt grey2 small-text">
                                            <span class="ic-img"> <img src="assets/images/icons/section_ic.svg" class="img-fluid me-2" /> </span>
                                            Sections: <span class="text-black  small-text-new">{{item.sec}}</span>
                                        </div>
                                        <div class="sect-b  l-txt grey2 small-text">
                                            <span class="ic-img"> <img src="assets/images/icons/exam_ic_grey.svg" class="img-fluid me-2" /></span>
                                            Exam:
                                            <span class="text-black  small-text-new " *ngIf="item.is_info==0">Yes</span>
                                            <span class="text-black  small-text-new" *ngIf="item.is_info==1">No</span>
                                        </div>
                                    </div>
                                    <div class="sect-a l-txt d-flex flex-wrap align-items-center">
                                        <div class="grey2 small-text">
                                            <span class="ic-img"><img src="assets/images/icons/certificate_ic_grey.svg"class="img-fluid mb-1 me-2" /></span>Certificate Expires:
                                        </div>
                                        <div class="ms-2 c-t">
                                            <span class=" text-black small-text-new" *ngIf="item.c_et==0">Never </span>
                                            <span class=" text-black small-text-new" *ngIf="item.c_et!=0">{{item.c_et}} Months</span>
                                        </div>
                                    </div>
                                <div class="p-b">
                                    <img src="assets/images/package/price.png" class="img-fluid"/><span class="ms-1 text-semibold">€{{item.pr}}</span>
                                </div>
                                <div class="d-flex justify-content-center  flex-wrap">
                                    <button type="button" (click)="onViewCourse(item)" 
                                        class="btn c-btn btn-outline-primary outline-btn justify-content-center d-flex mt-3 mt-xl-4 align-items-center v-btn ">
                                        <i class="material-icons me-1">remove_red_eye</i>{{"View" |translate}}</button>
                                    <button mat-raised-button color="primary" class="primary-btn c-btn no-sh-btn mt-3 mt-xl-4  " (click)="onBuyCourse(item.id,item)"
                                        type="submit"> <mat-icon class="kt-margin-r-0">shopping_cart</mat-icon> Buy</button>
                                </div>
                            </div>
                        </div>
                      </div>
                </div>
            </div>    
            <div class="mat-table__message" *ngIf="courseArr.length==0">
                <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
            </div>
            <div class="pagination-cont" *ngIf="courseArr.length!=0">
                <div class="show-item">
                    {{"COMMON.SIP" | translate}}
                  <select class="form-control sel-op ms-2 p-2 styled-dropdown " (change)="onPageSizeChange($event)" [(ngModel)]="config.itemsPerPage">
                    <option [value]="item" *ngFor="let item of pageSizeOptions">
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div class="page-c">
                  <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
                    [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)">
                </ngb-pagination>
                </div>
              </div>
        </div>
    </div>
</section>f